import secondaryComponents from "../..";
import { useGRItemsTable } from "./useGRItemsTable";
import styles from "./styles.module.scss";
import { PurchaseOrderImage } from "../../../../assets/svgImages";
import { OtherDetails } from "../GoodsReceivedForm/OtherDetails";
import { RoutedModal } from "../../../common";

export const GRItemsTable = ({ GRItems = [], GRDetails = null }) => {
  const { instance, isOtherDetails, setIsOtherDetails } = useGRItemsTable({
    GRItems,
    GRDetails,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div>
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={styles.grItemsTable}
          hasAction
        >
          <div className="pt-5 text-center">
            <PurchaseOrderImage />
            <h4>You have no Goods Received Notes</h4>
          </div>
        </secondaryComponents.TableHelper>
      </div>

      <RoutedModal
        isActive={isOtherDetails !== null}
        closeModal={() => setIsOtherDetails(null)}
        width={650}
        headerTitle="View Other Details"
        style={{ height: "auto" }}
      >
        <OtherDetails
          itemInfo={isOtherDetails}
          gRForm={{ items: GRItems }}
          setGRForm={() => {}}
          closeModal={() => setIsOtherDetails(null)}
          isDisabled={true}
        />
      </RoutedModal>
    </>
  );
};
